import { TAB_SHOW, TAB_HIDE } from '../../../../common/tabs/tabs.constants';
import * as Actions from './adm-accounts-clients.actions';
import { IDS } from './adm-accounts-clients-action-id.constants';
import get from 'lodash/get';

/**
 * @const {object}
 * @memberOf module:Administration
 */
export const admAccountsClients = {
    /* @ngInject */
    controller: function ($ngRedux, $state,  $timeout, $mdDialog, $rootScope, NavigationService,$uiRouterGlobals) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            const ctrl = this;
            const client = get($uiRouterGlobals.params, 'client');
            if(client) {
                $timeout(function() {
                    ctrl.onSelect({item: {cli_id: client}});
                },200);
            } else if (get($uiRouterGlobals.params, 'hof') === undefined) {
                $ngRedux.dispatch({
                    type: TAB_HIDE,
                    id: 'app.administration.accounts',
                    state: [
                        'app.administration.accounts.headOffices'
                    ],
                    stateParams: {}
                });
                $timeout(function() {
                    $ngRedux.dispatch({
                        type: TAB_SHOW,
                        id: 'app.administration.accounts',
                        state: [
                            'app.administration.accounts.headOffices'
                        ],
                        stateParams: {}
                    });
                },200);
            }
            const navConfig = NavigationService.getConfig($state.$current);
            this.colorName = navConfig.colorName;
            this.icon = navConfig.icon;

            this.unsubscribe = $ngRedux.connect(({ administration }) => ({
                clientDetails: administration.clientDetails
            }), Actions)(this);
        }

        this.onSelect = ({ item }) => {
            $ngRedux.dispatch({
                type: 'FILTER',
                id: IDS.admAccountsClients,
                path: IDS.admAccountsClientExternalRolesGrid,
                filter: { client_uuid: item.cli_id },
            });
            this.fetchClientAccountDetails(item.cli_id).then(() => {
                $ngRedux.dispatch({
                    type: TAB_SHOW,
                    id: 'app.administration.accounts',
                    state: [
                        IDS.app_administration_accounts_clientDetails
                    ],
                    stateParams: { client: item.cli_id }
                });
            });
        };

        this.onInvalidate = ({item}) => {
            this.removeClientAccount(item.cli_id);
        };

        this.onGridReset = (event) => {
            $ngRedux.dispatch({
                type: 'RESET_GRID_FILTER',
                id: IDS.admAccountsClientsGrid
            });
        };

        this.$onDestroy = () => {
            this.unsubscribe();
            this.dialog && $mdDialog.hide(this.dialog);
        };
    },
    template: `
        <adm-accounts-clients-grid
            on-select="$ctrl.onSelect($event)"
            on-remove="$ctrl.onInvalidate($event)"
            on-reset="$ctrl.onGridReset($event)">
        </adm-accounts-clients-grid>

<!--        <tabs-navigation identifier="app.administration.accounts"-->
<!--                         state="app.administration.accounts.clientAccountDetails"-->
<!--                         on-exec="$ctrl.addClient()">-->
<!--        </tabs-navigation>-->
    `
};
